import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { fetchNewsList, fetchCategories } from '../news/api';

const PAGE_SIZE = 9;
const fmt = (d) => (d || '').slice(0, 10);
const cardImage = (src = '') => src
  .replace('news-1782815639549-91275285-enhanced.jpg', 'news-1782815639549-91275285-card.jpg')
  .replace('news-1782815630502-7793fb63-enhanced.jpg', 'news-1782815630502-7793fb63-card.jpg');

export default function News() {
  const [categories, setCategories] = useState(['全部新闻']);
  const [active, setActive] = useState('全部新闻');
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories().then((cs) => setCategories(['全部新闻', ...cs])).catch(() => {});
  }, []);

  const load = useCallback(async (cat, pg, append) => {
    setLoading(true);
    try {
      const res = await fetchNewsList({ category: cat, page: pg, pageSize: PAGE_SIZE });
      setTotal(res.total);
      setItems((prev) => (append ? [...prev, ...res.items] : res.items));
    } catch { if (!append) setItems([]); } finally { setLoading(false); }
  }, []);

  useEffect(() => { setPage(1); load(active, 1, false); }, [active, load]);
  const hasMore = items.length < total;

  return (
    <div>
      {/* 页头 */}
      <section className="page-top pb-12 text-center">
        <div className="container-x">
          <div className="eyebrow mb-3 reveal">新闻中心</div>
          <h1 className="text-4xl md:text-6xl font-semibold tracking-tight reveal" style={{ color: 'var(--ink)', transitionDelay: '0.05s' }}>
            新闻中心
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg md:text-xl leading-relaxed reveal" style={{ color: 'var(--muted)', transitionDelay: '0.1s' }}>
            记录少年造物局的课程案例、活动动态与科创教育实践
          </p>
        </div>
      </section>

      {/* 分类导航 */}
      <div className="sticky top-12 z-30" style={{ background: 'rgba(251,251,253,0.8)', backdropFilter: 'blur(20px)', borderBottom: '1px solid var(--line)' }}>
        <div className="container-x flex flex-wrap justify-center gap-x-7 gap-y-2 py-3.5">
          {categories.map((c) => (
            <button key={c} onClick={() => setActive(c)}
              className="text-[14px] transition-opacity hover:opacity-60"
              style={{ color: active === c ? 'var(--ink)' : 'var(--muted)', fontWeight: active === c ? 600 : 400 }}>
              {c}
            </button>
          ))}
        </div>
      </div>

      {/* 列表 */}
      <section className="py-16 md:py-24">
        <div className="container-x">
          {loading && items.length === 0 ? (
            <p className="py-20 text-center" style={{ color: 'var(--muted)' }}>加载中…</p>
          ) : items.length === 0 ? (
            <p className="py-20 text-center" style={{ color: 'var(--muted)' }}>该分类下暂无新闻</p>
          ) : (
            <div className="grid gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
              {items.map((n) => (
                <Link key={n.id} to={`/news/${n.slug}`} className="group block">
                  <div className="overflow-hidden aspect-[16/9]" style={{ borderRadius: '16px', background: 'var(--bg-alt)' }}>
                    {n.coverImage && (
                      <img src={cardImage(n.coverImage)} alt={n.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.01]" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                    )}
                  </div>
                  <div className="mt-4 text-[13px]" style={{ color: 'var(--muted)' }}>{n.category} · {fmt(n.publishDate)}</div>
                  <h3 className="mt-1.5 text-[19px] font-semibold leading-snug transition-opacity group-hover:opacity-70" style={{ color: 'var(--ink)' }}>{n.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed line-clamp-2" style={{ color: 'var(--muted)' }}>{n.summary}</p>
                </Link>
              ))}
            </div>
          )}

          {hasMore && (
            <div className="mt-16 text-center">
              <button onClick={() => { const np = page + 1; setPage(np); load(active, np, true); }} disabled={loading} className="btn btn-white">
                {loading ? '加载中…' : '加载更多'}
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}